export default __webpack_public_path__ + "static/media/openBox.e60562ec.svg";